import $ from 'jquery';

function print(e) {
    if (e.type === 'keypress' && e.which !== 13) {
        return;
    }

    window.print();
}

function attachEvents(id) {
    $("#" + id).on('click keypress', print);
};


export var init = function (id) {
    attachEvents(id);
};